import { MapElementFactory } from 'vue2-google-maps';

export default MapElementFactory({
    name: 'HeatMapLayer',
    ctr: () => google.maps.visualization.HeatmapLayer,
    //// The following is optional, but necessary if the constructor takes multiple arguments
    //// e.g. for GroundOverlay
    // ctrArgs: (options, otherProps) => [options],
    events: [],
    mappedProps: {
        data: { type: Array },
        options: { type: Object },
    },
    // Any other properties you want to bind. Note: Must be in Object notation
    props: {},
    // Actions you want to perform before creating the object instance using the
    // provided constructor (for example, you can modify the `options` object).
    // If you return a promise, execution will suspend until the promise resolves
    beforeCreate(options) {},
    // Actions to perform after creating the object instance.
    afterCreate(hml) {
        hml.setMap(hml.map);
    },
});
